import React, { useContext, useEffect } from "react";
import * as styles from "./InspectionSyncState.module.scss";
import classNames from "classnames";
import { Await, useAsyncValue, useLoaderData } from "react-router-dom";
import { SaveInspectionContext } from "@app/components/SaveInspectionContextContainer/SaveInspectionContextContainer.jsx";

const Handler = () => {
	const pendingAction = useAsyncValue();
	const status = pendingAction?.response?.status;
	useEffect(() => {
		if (status === 403) {
			sessionStorage.setItem("saveInspectionPending", "true");
			document.cookie = `redirectTo=${encodeURIComponent(window.location.pathname)}; Path=/; Max-Age=600; SameSite=Lax`;
			window.location.href = `${Config.API.BASE_PATH}/auth?app=tempton_azure`;
		}
	}, [status]);

	return null;
	/*return pendingAction?.success ? (
		<p>{status}: Synchronisation war erfolgreich.</p>
	) : (
		<p>{status}: Synchronisation war nicht erfolgreich.</p>
	);*/
};

const InspectionSyncState = () => {
	const { syncRequest } = useLoaderData();
	const InspectionSyncStateClassName = classNames({
		[styles["inspection-sync-state"]]: true,
	});
	const saveInspectionPending = sessionStorage.getItem("saveInspectionPending");
	const { saveInspectionHandler } = useContext(SaveInspectionContext);
	useEffect(() => {
		if (saveInspectionPending === "true" && saveInspectionHandler?.fn) {
			sessionStorage.removeItem("saveInspectionPending");
			saveInspectionHandler.fn();
		}
	}, [saveInspectionPending, saveInspectionHandler]);

	return (
		<div className={InspectionSyncStateClassName}>
			{syncRequest && (
				<React.Suspense /*fallback={<p>Synchronisation läuft</p>}*/>
					<Await resolve={syncRequest} /*errorElement={<p>Fehler bei Synchronisation mit dem Server</p>}*/>
						<Handler />
					</Await>
				</React.Suspense>
			)}
		</div>
	);
};

InspectionSyncState.propTypes = {};

export default InspectionSyncState;
